import { createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import { ContactForm } from ".";
import { addContactUs } from "../../firebase/contactus";
import { formatError } from "../../utils";

export const submitForm = createAsyncThunk(
    "contact/submitForm",
    async (data: ContactForm, { rejectWithValue }): Promise<any> => {
        try {
            let result = await addContactUs(data);
            notification.success({ message: "Request Submitted Sucessfully, We'll get back to you shortly" });
            return result;
        } catch (error: any) {
            console.log("error ", error);
            notification.error({ message: "Form Submission Failed", description: formatError(error.code) });
            return rejectWithValue("oops !!! something went wrong, please try again.");
        }
    }
);
